module.exports = __webpack_public_path__ + "img/pbtm4.08af6081.png";